export default function getRestUrl(path: string): string {
  const baseUrl = process.env.REACT_APP_REST_URL as string;
  return `${baseUrl}${path}`;
}
